import { useState, useCallback } from 'react';
import usePayment from 'state/payment/hooks/usePayment';
import { ToastType } from 'components/toasts/container';
import { TransactionToastType, TransactionTableData, UseTransactionActionsReturn } from '../types';
import { getToastMessage, isFailedToastType, TOAST_MESSAGES } from '../constants';

export function useTransactionActions(): UseTransactionActionsReturn {
  const [toastType, setToastType] = useState<TransactionToastType | null>(null);
  const [warningType, setWarningType] = useState<ToastType | undefined>(ToastType.success);

  const { toCancelTransaction, toChargeRefund } = usePayment();

  const handleCancel = useCallback(
    async (row: TransactionTableData) => {
      const response = await toCancelTransaction(row.order_id);
      if (response) {
        setToastType(TransactionToastType.CANCEL);
        setWarningType(ToastType.success);
      } else {
        setToastType(TransactionToastType.FAILED_CANCEL);
        setWarningType(ToastType.error);
      }
    },
    [toCancelTransaction]
  );

  const handleRefund = useCallback(
    async (row: TransactionTableData) => {
      try {
        const refundRequest = {
          paymentId: row.gateway_id ?? '',
          triggerProcessorSync: true,
        };

        const response = await toChargeRefund(refundRequest);
        if (response) {
          setToastType(TransactionToastType.REFUND);
          setWarningType(ToastType.success);
        } else {
          setToastType(TransactionToastType.FAILED_REFUND);
          setWarningType(ToastType.error);
        }
      } catch (err) {
        console.error('Refund payment error:', err);
        setToastType(TransactionToastType.FAILED_REFUND);
        setWarningType(ToastType.error);
      }
    },
    [toChargeRefund]
  );

  const clearToast = useCallback(() => {
    setToastType(null);
  }, []);

  const toastMessage = getToastMessage(toastType);

  const toastSubDetails = isFailedToastType(toastType) ? (
    <p>{TOAST_MESSAGES.ERROR_UNABLE_TO_PERFORM}</p>
  ) : undefined;

  return {
    toastType,
    warningType,
    toastMessage,
    toastSubDetails,
    handleCancel,
    handleRefund,
    clearToast,
  };
}
